import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AddClient from "../../components/Client/AddClient";
import AllClients from "../../containers/Pages/Clients/ClientData/ClientData";
// import asyncComponent from "util/asyncComponent";

const Clients = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/allClients`} />
    {/* <Route path={`${match.url}/allClients`} component={asyncComponent(() => import('./data'))}/> */}
    <Route path={`${match.url}/allClients`} component={AllClients} />
    <Route path={`${match.url}/addClient`} component={AddClient} />
    <Route path={`${match.url}/updateClient/:id`} component={AddClient} />
  </Switch>
);

export default Clients;